// import React from "react";
// import { useNavigate } from "react-router-dom";
// import "./LandingPage.css";

// const VERTICALS = [
//   {
//     id: "stay",
//     title: "Stay / Accommodation",
//     subtitle:
//       "Hotels, resorts, villas, homestays, apartments & hostels",
//     icon: "⌂",
//     image:
//       "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=900&q=85",
//   },
//   {
//     id: "bus",
//     title: "Bus",
//     subtitle:
//       "Bus operators & fleet owners — intercity, tourist, contract",
//     icon: "▣",
//     image:
//       "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=900&q=85",
//   },
//   {
//     id: "cab",
//     title: "Cab / Car Rental / Transfers",
//     subtitle:
//       "Taxi, chauffeur, airport transfers, car rentals",
//     icon: "◉",
//     image:
//       "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=900&q=85",
//   },
//   {
//     id: "packages",
//     title: "Tour / Holiday Packages",
//     subtitle:
//       "Tour operators, DMCs, group and private holiday packages",
//     icon: "♙",
//     image:
//       "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?auto=format&fit=crop&w=900&q=85",
//   },
//   {
//     id: "activities",
//     title: "Activities / Experiences",
//     subtitle:
//       "Attractions, adventures, guided experiences",
//     icon: "◇",
//     image:
//       "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=85",
//   },
//   {
//     id: "events",
//     title: "Events / Nightlife",
//     subtitle:
//       "Concerts, festivals, clubs, entertainment venues",
//     icon: "♪",
//     image:
//       "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=900&q=85",
//   },
//   {
//     id: "darshan",
//     title: "Darshan / Religious",
//     subtitle:
//       "Temples, trusts, pilgrimage, puja & special access",
//     icon: "♜",
//     image:
//       "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=900&q=85",
//   },
//   {
//     id: "cruise",
//     title: "Cruise",
//     subtitle:
//       "Ocean, river, yacht & charter cruise operators",
//     icon: "≈",
//     image:
//       "https://images.unsplash.com/photo-1548574505-5e239809ee19?auto=format&fit=crop&w=900&q=85",
//   },
// ];

// export default function LandingPage() {
//   const navigate = useNavigate();

//   const goSignup = (vertical = "") => {
//     if (vertical) {
//       localStorage.setItem("selectedVertical", vertical);
//       navigate(`/signup?vertical=${vertical}`);
//     } else {
//       navigate("/signup");
//     }
//   };

//   const scrollTo = (id) => {
//     document
//       .getElementById(id)
//       ?.scrollIntoView({ behavior: "smooth" });
//   };

//   return (
//     <div className="lp-page">
//       <header className="lp-nav">
//         <button
//           className="lp-brand"
//           onClick={() =>
//             window.scrollTo({
//               top: 0,
//               behavior: "smooth",
//             })
//           }
//         >
//           <span className="lp-brand-mark">B</span>

//           <span className="lp-brand-name">
//             <b>BMT</b>
//             <em>Connect</em>
//           </span>
//         </button>

//         <nav className="lp-links">
//           <button onClick={() => scrollTo("verticals")}>
//             Verticals
//           </button>

//           <button onClick={() => scrollTo("why")}>
//             Why partner
//           </button>

//           <button onClick={() => scrollTo("how")}>
//             How it works
//           </button>
//         </nav>

//         <div className="lp-actions">
//          <button
//   className="lp-signin"
//   onClick={() => navigate("/vendor-login")}
// >
//   Sign in
// </button>

//           <button
//             className="lp-list"
//             onClick={() => goSignup()}
//           >
//             List your business →
//           </button>
//         </div>
//       </header>

//       <section className="lp-hero">
//         <div className="lp-hero-overlay" />

//         <div className="lp-hero-inner">
//           <span className="lp-kicker">
//             BIRDMYTRIP • TRAVEL COMMERCE INFRASTRUCTURE
//           </span>

//           <h1>
//             List your travel business
//             <br />
//             globally,
//             <br />
//             grow with a single supplier
//             <br />
//             platform.
//           </h1>

//           <p>
//             Manage stays, transport, tours, activities,
//             events, darshan and cruises from one
//             professional extranet — with verified
//             onboarding, payouts and analytics built for
//             scale.
//           </p>

//           <div className="lp-hero-buttons">
//             <button
//               className="lp-primary"
//               onClick={() => goSignup()}
//             >
//               Start free application →
//             </button>
// <button
//   className="lp-secondary"
//   onClick={() => navigate("/vendor-login")}
// >
//   Sign in to your account
// </button>
//           </div>

//           <div className="lp-stats">
//             <div>
//               <strong>8</strong>
//               <span>Verticals supported</span>
//             </div>

//             <div>
//               <strong>50+</strong>
//               <span>Countries</span>
//             </div>

//             <div>
//               <strong>24/7</strong>
//               <span>Partner support</span>
//             </div>

//             <div>
//               <strong>T+2</strong>
//               <span>Payout SLA</span>
//             </div>
//           </div>
//         </div>
//       </section>

//       <section
//         id="verticals"
//         className="lp-section"
//       >
//         <div className="lp-section-top">
//           <div>
//             <span className="lp-small-kicker">
//               AVAILABLE BUSINESSES
//             </span>

//             <h2>
//               List any of these travel businesses
//             </h2>
//           </div>

//           <p>
//             Pick your business type during onboarding.
//             The registration adapts to your vertical —
//             documents, product setup, payouts and dashboard.
//           </p>
//         </div>

//         <div className="lp-vertical-grid">
//           {VERTICALS.map((v) => (
//             <button
//               key={v.id}
//               className="lp-vertical-card"
//               onClick={() => goSignup(v.id)}
//             >
//               <img
//                 src={v.image}
//                 alt={v.title}
//               />

//               <div className="lp-card-body">
//                 <h3>
//                   <span>{v.icon}</span>
//                   {v.title}
//                 </h3>

//                 <p>{v.subtitle}</p>
//               </div>
//             </button>
//           ))}
//         </div>
//       </section>

//       <section
//         id="why"
//         className="lp-feature-strip"
//       >
//         <div>
//           <span>◎</span>
//           <h3>Global reach</h3>
//           <p>
//             Sell across BirdMyTrip channels with localized
//             currency, tax and payout.
//           </p>
//         </div>

//         <div>
//           <span>◈</span>
//           <h3>Verified & compliant</h3>
//           <p>
//             Country-aware KYC, document verification and
//             expiry monitoring built-in.
//           </p>
//         </div>

//         <div>
//           <span>ϟ</span>
//           <h3>Built for scale</h3>
//           <p>
//             From single-property owners to multi-vertical
//             DMCs — dashboards adapt automatically.
//           </p>
//         </div>
//       </section>

//       <section
//         id="how"
//         className="lp-section lp-how"
//       >
//         <span className="lp-small-kicker">
//           PLATFORM ONBOARDING
//         </span>

//         <h2>
//           Join in 4 simple steps
//         </h2>

//         <div className="lp-how-grid">
//           <div>
//             <b>01</b>
//             <h3>Apply for entry</h3>
//             <p>Account + basic business details</p>
//           </div>

//           <div>
//             <b>02</b>
//             <h3>Application review</h3>
//             <p>KYC and verification checks</p>
//           </div>

//           <div>
//             <b>03</b>
//             <h3>Contract signing</h3>
//             <p>Commercial and payout setup</p>
//           </div>

//           <div>
//             <b>04</b>
//             <h3>Success!</h3>
//             <p>Your business goes live</p>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const VERTICALS = [
  { id: "stay", title: "Stay / Accommodation", subtitle: "Hotels, resorts, villas, homestays, apartments & hostels", icon: "⌂", image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=900&q=85" },
  { id: "bus", title: "Bus", subtitle: "Bus operators & fleet owners — intercity, tourist, contract", icon: "▣", image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=900&q=85" },
  { id: "cab", title: "Cab / Car Rental / Transfers", subtitle: "Taxi, chauffeur, airport transfers, car rentals", icon: "◉", image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=900&q=85" },
  { id: "packages", title: "Tour / Holiday Packages", subtitle: "Tour operators, DMCs, group and private holiday packages", icon: "♙", image: "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?auto=format&fit=crop&w=900&q=85" },
  { id: "activities", title: "Activities / Experiences", subtitle: "Attractions, adventures, guided experiences", icon: "◇", image: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=85" },
  { id: "events", title: "Events / Nightlife", subtitle: "Concerts, festivals, clubs, entertainment venues", icon: "♪", image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=900&q=85" },
  { id: "darshan", title: "Darshan / Religious", subtitle: "Temples, trusts, pilgrimage, puja & special access", icon: "♜", image: "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=900&q=85" },
  { id: "cruise", title: "Cruise", subtitle: "Ocean, river, yacht & charter cruise operators", icon: "≈", image: "https://images.unsplash.com/photo-1548574505-5e239809ee19?auto=format&fit=crop&w=900&q=85" },
];

const PRIVACY = {
  updated: "September 2026",
  intro: [
    "Birdella International Private Limited (“Company”, “we”, “us”, or “our”) operates the BirdMyTrip application and website (“Platform”). We are committed to protecting your privacy and ensuring the security of your personal data.",
    "This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Platform to access our 12 travel and lifestyle verticals (Flights, Stays, Cabs, Buses, etc.). Please read this policy carefully.",
  ],
  sections: [
    { title: "1. Information we collect", items: [
      "We collect information that identifies you or can be used to contact you, as well as data related to your travel preferences:",
      "Personal Information: Name, email address, mobile number, postal address, gender, and date of birth (required for bookings and verification).",
      "Identity & KYC Documents: Government-issued IDs, passport details, or visa documents when required for specific verticals (e.g., International Flights, Visas, BMT Darshan).",
      "Payment & Financial Data: Bank account details, credit/debit card numbers, and UPI handles processed securely through our third-party payment gateway partners. We do not store complete card credentials.",
      "Booking & Transaction History: Details of past, ongoing, and upcoming bookings across all verticals, trip carts, and wishlist items.",
      "Device & Technical Data: IP address, browser type, operating system, mobile device identifiers, app version, and crash logs.",
      "Location Data: Precise or approximate GPS location data when you use features like Cab/Bus booking, live trip tracking, and the Trip Safety Companion.",
      "Biometric Data: Facial or fingerprint data solely for secure app login, processed locally on your device where permitted.",
    ]},
    { title: "2. How we use your information", items: [
      "We use the collected information for various business and operational purposes, including:",
      "Processing and confirming your bookings across all verticals and generating GST-compliant invoices.",
      "Managing your BMT Digital Wallet, loyalty rewards, and referral bonuses.",
      "Enabling communication between you and service Vendors (e.g., sharing your contact number with a cab driver or hotel).",
      "Providing customer support, handling cancellations/refunds, and resolving disputes via the Help Center.",
      "Sending transactional alerts, booking confirmations, price-drop alerts, and promotional offers (with an option to opt out).",
      "Improving Platform security, fraud prevention, and enforcing our Terms and Conditions.",
    ]},
    { title: "3. Sharing and disclosure of information", items: [
      "We do not sell your personal data. However, we may share your information with trusted third parties under strict confidentiality:",
      "Service Vendors: Airlines, hotels, bus operators, cab drivers, night clubs, and tour operators to fulfill your requested bookings.",
      "Third-Party Integration Partners: GDS/NDC flight aggregators, visa-processing agencies, and travel insurance providers.",
      "Payment Gateways & Financial Partners: To securely process transactions and issue refunds.",
      "Legal & Regulatory Authorities: When required by law, court order, or government regulation, or to protect the rights, property, or safety of Birdella International Pvt. Ltd., our users, or others.",
    ]},
    { title: "4. Data security", items: [
      "We implement robust administrative, technical, and physical security measures to safeguard your personal data. This includes encryption of data in transit (SSL/TLS), secure tokenized payments, and restricted access to internal databases. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.",
    ]},
    { title: "5. Your data rights and choices", items: [
      "Access & Update: You can review and update your profile information directly through your account settings on the Platform.",
      "Marketing Opt-Out: You can opt out of receiving promotional emails and notifications by adjusting your notification preferences within the app.",
      "Account Deletion: You can request the deletion of your account by contacting our support team. Note that certain transactional data may be retained for legal, tax, and auditing purposes.",
    ]},
    { title: "6. Cookies and tracking technologies", items: [
      "Our website uses cookies and similar tracking technologies to enhance user experience, analyze traffic patterns, and remember your preferences. You can configure your browser to refuse cookies, though some features of the Platform may not function properly as a result.",
    ]},
    { title: "7. Children’s privacy", items: [
      "The Platform is not directed at individuals under the age of 18. We do not knowingly collect personal data from minors. If a booking requires a minor, it must be made by an adult legal guardian.",
    ]},
    { title: "8. Changes to this Privacy Policy", items: [
      "We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. The updated version will be indicated by the “Last Updated” date at the top of this policy. Continued use of the Platform after changes constitutes your acceptance of the revised policy.",
    ]},
    { title: "9. Contact us", items: [
      "If you have any questions, concerns, or grievances regarding this Privacy Policy or the handling of your personal data, please contact our Grievance Officer:",
      "Name: [To be filled]",
      "Email: privacy@birdmytrip.com / grievance@birdmytrip.com",
      "Address: Birdella International Private Limited, [Registered Office Address, Noida/Farrukhabad]",
    ]},
  ],
};

const FOOTER_CSS = `
.lp-footer{background:#0b1a2e;color:#b8c4d6;padding:64px 6vw 0;font-size:14px;line-height:1.6}
.lp-footer-inner{max-width:1200px;margin:0 auto;display:grid;grid-template-columns:1.6fr 1fr 1.2fr;gap:48px;padding-bottom:48px}
.lp-footer-logo{display:flex;align-items:center;gap:10px;color:#fff;margin-bottom:14px}
.lp-footer-mark{width:34px;height:34px;border-radius:8px;background:#1b4b9b;color:#fff;display:grid;place-items:center;font-weight:700}
.lp-footer-name{font-weight:600;font-size:17px}
.lp-footer-brand p{max-width:340px;margin:0}
.lp-footer-col{display:flex;flex-direction:column;align-items:flex-start;gap:10px}
.lp-footer-col h4{margin:0 0 6px;color:#fff;font-size:15px;font-weight:600}
.lp-footer a,.lp-footer-col button{color:#b8c4d6;text-decoration:none;background:none;border:0;padding:0;font:inherit;cursor:pointer;text-align:left}
.lp-footer a:hover,.lp-footer-col button:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}
.lp-footer a:focus-visible,.lp-footer-col button:focus-visible{outline:2px solid #7fb4ff;outline-offset:3px}
.lp-footer-bottom{max-width:1200px;margin:0 auto;border-top:1px solid rgba(255,255,255,.12);padding:20px 0 28px;display:flex;justify-content:space-between;flex-wrap:wrap;gap:12px;font-size:13px}
.lp-modal-backdrop{position:fixed;inset:0;background:rgba(5,12,24,.6);z-index:1000;display:flex;align-items:center;justify-content:center;padding:20px}
.lp-modal{background:#fff;color:#1b2433;width:100%;max-width:760px;max-height:88vh;border-radius:12px;display:flex;flex-direction:column;overflow:hidden}
.lp-modal-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:22px 26px;border-bottom:1px solid #e6eaf0}
.lp-modal-head h2{margin:0;font-size:22px}
.lp-modal-head small{color:#6b778c}
.lp-modal-close{border:0;background:#eef1f6;border-radius:8px;width:36px;height:36px;font-size:20px;cursor:pointer;color:#1b2433}
.lp-modal-close:focus-visible{outline:2px solid #1b4b9b;outline-offset:2px}
.lp-modal-body{padding:8px 26px 28px;overflow-y:auto;line-height:1.7}
.lp-modal-body h3{font-size:16px;margin:26px 0 8px}
.lp-modal-body p{margin:0 0 10px;font-size:15px}
@media(max-width:900px){.lp-footer-inner{grid-template-columns:1fr 1fr;gap:36px}.lp-footer-brand{grid-column:1/-1}}
@media(max-width:520px){.lp-footer-inner{grid-template-columns:1fr}.lp-footer-bottom{flex-direction:column}.lp-modal-head,.lp-modal-body{padding-left:18px;padding-right:18px}}
`;

export default function LandingPage() {
  const navigate = useNavigate();
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    if (!showPrivacy) return;
    const onKey = (e) => e.key === "Escape" && setShowPrivacy(false);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [showPrivacy]);

  const goSignup = (vertical = "") => {
    if (vertical) {
      localStorage.setItem("selectedVertical", vertical);
      navigate(`/signup?vertical=${vertical}`);
    } else {
      navigate("/signup");
    }
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="lp-page">
      <style>{FOOTER_CSS}</style>

      <header className="lp-nav">
        <button className="lp-brand" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          <span className="lp-brand-mark">B</span>
          <span className="lp-brand-name">
            <b>BMT</b>
            <em>Connect</em>
          </span>
        </button>

        <nav className="lp-links">
          <button onClick={() => scrollTo("verticals")}>Verticals</button>
          <button onClick={() => scrollTo("why")}>Why partner</button>
          <button onClick={() => scrollTo("how")}>How it works</button>
        </nav>

        <div className="lp-actions">
          <button className="lp-signin" onClick={() => navigate("/vendor-login")}>Sign in</button>
          <button className="lp-list" onClick={() => goSignup()}>List your business →</button>
        </div>
      </header>

      <section className="lp-hero">
        <div className="lp-hero-overlay" />
        <div className="lp-hero-inner">
          <span className="lp-kicker">BIRDMYTRIP • TRAVEL COMMERCE INFRASTRUCTURE</span>

          <h1>
            List your travel business
            <br />
            globally,
            <br />
            grow with a single supplier
            <br />
            platform.
          </h1>

          <p>
            Manage stays, transport, tours, activities, events, darshan and
            cruises from one professional extranet — with verified onboarding,
            payouts and analytics built for scale.
          </p>

          <div className="lp-hero-buttons">
            <button className="lp-primary" onClick={() => goSignup()}>Start free application →</button>
            <button className="lp-secondary" onClick={() => navigate("/vendor-login")}>Sign in to your account</button>
          </div>

          <div className="lp-stats">
            <div><strong>8</strong><span>Verticals supported</span></div>
            <div><strong>50+</strong><span>Countries</span></div>
            <div><strong>24/7</strong><span>Partner support</span></div>
            <div><strong>T+2</strong><span>Payout SLA</span></div>
          </div>
        </div>
      </section>

      <section id="verticals" className="lp-section">
        <div className="lp-section-top">
          <div>
            <span className="lp-small-kicker">AVAILABLE BUSINESSES</span>
            <h2>List any of these travel businesses</h2>
          </div>
          <p>
            Pick your business type during onboarding. The registration adapts
            to your vertical — documents, product setup, payouts and dashboard.
          </p>
        </div>

        <div className="lp-vertical-grid">
          {VERTICALS.map((v) => (
            <button key={v.id} className="lp-vertical-card" onClick={() => goSignup(v.id)}>
              <img src={v.image} alt={v.title} />
              <div className="lp-card-body">
                <h3><span>{v.icon}</span>{v.title}</h3>
                <p>{v.subtitle}</p>
              </div>
            </button>
          ))}
        </div>
      </section>

      <section id="why" className="lp-feature-strip">
        <div>
          <span>◎</span>
          <h3>Global reach</h3>
          <p>Sell across BirdMyTrip channels with localized currency, tax and payout.</p>
        </div>
        <div>
          <span>◈</span>
          <h3>Verified & compliant</h3>
          <p>Country-aware KYC, document verification and expiry monitoring built-in.</p>
        </div>
        <div>
          <span>ϟ</span>
          <h3>Built for scale</h3>
          <p>From single-property owners to multi-vertical DMCs — dashboards adapt automatically.</p>
        </div>
      </section>

      <section id="how" className="lp-section lp-how">
        <span className="lp-small-kicker">PLATFORM ONBOARDING</span>
        <h2>Join in 4 simple steps</h2>

        <div className="lp-how-grid">
          <div><b>01</b><h3>Apply for entry</h3><p>Account + basic business details</p></div>
          <div><b>02</b><h3>Application review</h3><p>KYC and verification checks</p></div>
          <div><b>03</b><h3>Contract signing</h3><p>Commercial and payout setup</p></div>
          <div><b>04</b><h3>Success!</h3><p>Your business goes live</p></div>
        </div>
      </section>

      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-brand">
            <div className="lp-footer-logo">
              <span className="lp-footer-mark">B</span>
              <span className="lp-footer-name">BMT Connect</span>
            </div>
            <p>
              The supplier extranet of BirdMyTrip. List stays, transport, tours,
              activities, events, darshan and cruises from one place.
            </p>
          </div>

          <div className="lp-footer-col">
            <h4>Platform</h4>
            <button onClick={() => scrollTo("verticals")}>Verticals</button>
            <button onClick={() => scrollTo("why")}>Why partner</button>
            <button onClick={() => scrollTo("how")}>How it works</button>
            <button onClick={() => navigate("/vendor-login")}>Sign in</button>
          </div>

          <div className="lp-footer-col">
            <h4>Legal & contact</h4>
            <button onClick={() => setShowPrivacy(true)}>Privacy Policy</button>
            <a href="mailto:support@birdmytrip.com">support@birdmytrip.com</a>
            <a href="mailto:privacy@birdmytrip.com">privacy@birdmytrip.com</a>
          </div>
        </div>

        <div className="lp-footer-bottom">
          <span>© {new Date().getFullYear()} Birdella International Private Limited. All rights reserved.</span>
          <button style={{ color: "#b8c4d6", background: "none", border: 0, cursor: "pointer", font: "inherit", padding: 0 }} onClick={() => setShowPrivacy(true)}>
            Privacy Policy
          </button>
        </div>
      </footer>

      {showPrivacy && (
        <div className="lp-modal-backdrop" onClick={() => setShowPrivacy(false)}>
          <div className="lp-modal" role="dialog" aria-modal="true" aria-labelledby="pp-title" onClick={(e) => e.stopPropagation()}>
            <div className="lp-modal-head">
              <div>
                <h2 id="pp-title">Privacy Policy</h2>
                <small>Last updated: {PRIVACY.updated}</small>
              </div>
              <button className="lp-modal-close" aria-label="Close privacy policy" onClick={() => setShowPrivacy(false)}>×</button>
            </div>
            <div className="lp-modal-body">
              {PRIVACY.intro.map((t, i) => <p key={i}>{t}</p>)}
              {PRIVACY.sections.map((s) => (
                <div key={s.title}>
                  <h3>{s.title}</h3>
                  {s.items.map((t, i) => <p key={i}>{t}</p>)}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}